<template>
    <div class="content">

        <div class="md-layout">
            <div class="md-layout-item md-medium-size-100 md-size-100">

                <md-card>
                    <md-card-header data-background-color="purple" style="text-align: center;">
                        <h4 class="title">ស្កេនចេញកញ្ចប់ឥវ៉ាន់ ONE & ME EXPRESS</h4>
                    </md-card-header>
                    <md-card-content  v-if="scanner_admin != ''">
                        <div class="md-layout-item md-medium-size-100 md-size-100 text-center" style="margin: 0px 0 50px 0; text-align: center;display: flex;align-items: center;flex-direction: column;">

                            <div class="qr-container" style="width: 100%; max-width: 500px; aspect-ratio: 1 / 1;">
                                <qrcode-stream @decode="onDecode" @detect="onDetect" style="width:100%;height: 100%;"
                                ref="qrStream"></qrcode-stream>
                            </div>
                            
                            <h4>សូមធ្វើការស្កេន QR Code </h4>
                            <p>{{scanner_admin}}</p>
                        </div>
                    </md-card-content>
                    <md-card-content v-if="scanner_admin == ''">
                        <h4>សូមធ្វើការបញ្ចូលឈ្មោះអ្នក Scan </h4>
                        <md-field>
                            <label>ឈ្មោះអ្នក Scan</label>
                            <md-input v-model="input" type="text"></md-input>
                        </md-field>
                        <md-button class="md-primary" @click="set_scanner_admin()">បញ្ចូល</md-button>

                    </md-card-content>
                </md-card>
            </div>
            <div class="md-layout-item md-medium-size-100 md-size-100 text-center">
                <md-button class="md-secondary" @click="logout()">ចាកចេញ</md-button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        components: {
        },
        mounted() {
            if (this.$store.state.authentication.mode != "scanner") { this.$router.push("/404"); }
        },
        data() {
            return {
                captured: null,
                input: "",
                scanner_admin: this.config.getCookie("scanner_admin")
            }
        },
        methods: {
            logout() {
				this.$store.state.authentication.loggedIn = false;
				this.$store.state.authentication.authToken = null;
				this.$store.state.authentication.mode = "normal";
				this.$cookie.set('mode', "normal", 10);
				this.$cookie.delete('scanner_admin');
                this.$router.push("/");
			},
            onDetect(promise) {
                // var self = this;
                // promise.then(data => {
                //     // console.log(data);
                // })
                // console.log("hi");
            },
            onDecode(qr) {
                qr = this.config.decrypt(qr);

                if(qr.length != 20) return false;

                const video = this.$refs.qrStream.$el.querySelector('.video') || this.$refs.qrStream.$el.querySelector('video');

                const canvas = document.createElement('canvas')
                canvas.width = video.videoWidth
                canvas.height = video.videoHeight

                const ctx = canvas.getContext('2d');
                ctx.drawImage(video, 0, 0, canvas.width, canvas.height);

                canvas.toBlob((blob) => {
                    if (!blob) return;

                    this.track_package(qr, blob);
                }, 'image/jpeg', 0.5);

            },
            track_package(qr_string, imageBlob) {
                const formData = new FormData();

                formData.append('code', qr_string);
                formData.append('image', imageBlob, 'package.jpg');

                this.$http.post(this.config.api + '/driver/package/track', formData).then(res => {
                    if(res.body.status == "success") {
                        this.$notification.notify({
								message: "បញ្ចូលកញ្ចប់ឥវ៉ាន់បានជោគជ័យ។",
								icon: 'done',
								type: 'success'
							})
                    }
                });
            },
            set_scanner_admin() {
                if(String(this.input).length > 2) {
                    this.$cookie.set("scanner_admin", this.input, 10);
                    this.scanner_admin = this.input;
                }
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/pages/Scanner.vue